export const flightEngineTrueFalseMapping = {
  "": "-----",
  true: "Yes",
  false: "No",
};
